import React from "react";
import { Globe, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useLang, LANGS } from "../context/LanguageContext";

export const LangMenu = () => {
  const { lang, setLang } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="lang-menu-trigger" aria-label="language" className="flex items-center gap-1.5 px-2.5 py-1.5 text-sm font-medium text-zinc-300 hover:text-white rounded-lg hover:bg-white/5 transition-colors">
          <Globe className="h-4 w-4" /><span className="uppercase">{lang}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-zinc-950 border-white/10 text-white w-52 max-h-[70vh] overflow-y-auto p-1" data-testid="lang-menu">
        {LANGS.map(([code, name, flag]) => (
          <DropdownMenuItem key={code} onClick={() => setLang(code)} data-testid={`lang-option-${code}`}
            className={`flex items-center gap-2.5 rounded-md cursor-pointer focus:bg-white/10 focus:text-white ${lang === code ? "text-yellow-400" : ""}`}>
            <span className="text-base leading-none">{flag}</span>
            <span className="flex-1">{name}</span>
            <span className="text-[10px] uppercase text-zinc-500">{code}</span>
            {lang === code && <Check className="h-3.5 w-3.5" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
